var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    {
      attrs: { "three-line": "" },
      on: {
        click: function ($event) {
          return _vm.showDetail(_vm.distinta)
        },
      },
    },
    [
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", [
            _c("strong", [
              _vm._v("Colore: "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.distinta.idColore) +
                    " " +
                    _vm._s(_vm.distinta.descrizioneColore)
                ),
              ]),
            ]),
          ]),
          _c("v-list-item-subtitle", [
            _vm._v("Stagione: "),
            _c("strong", [_vm._v(_vm._s(_vm.distinta.idStagione) + " ")]),
            _vm._v(" - Codice taglia: "),
            _vm.distinta.lineaVendita
              ? _c("strong", [_vm._v(_vm._s(_vm.distinta.taglia))])
              : _vm._e(),
            _c("span", [
              _vm._v(" - Linea vendita: "),
              _c("strong", [_vm._v(_vm._s(_vm.distinta.lineaVendita))]),
            ]),
            _vm._v(" "),
            _c("em", [
              _vm._v("(id " + _vm._s(_vm.distinta.idDistintaDPC) + ")"),
            ]),
          ]),
        ],
        1
      ),
      _vm.distinta.contieneConsumiDaValidare
        ? _c(
            "v-list-item-avatar",
            [
              _c(
                "v-icon",
                {
                  staticClass: "amber lighten-1 white--text",
                  attrs: {
                    title: "Contiene variazioni in attesa di validazione",
                  },
                },
                [_vm._v(" mdi-exclamation-thick ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.distinta.draft
        ? _c(
            "v-list-item-avatar",
            [
              _c(
                "v-icon",
                {
                  staticClass: "primary white--text",
                  attrs: {
                    title: "Contiene variazioni in attesa di sincronizzazione",
                  },
                },
                [_vm._v(" mdi-cloud-sync ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.distinta.contieneVariazioniConsolidate
        ? _c(
            "v-list-item-avatar",
            [
              _c(
                "v-icon",
                {
                  staticClass: "green white--text",
                  attrs: { title: "Contiene variazioni sincronizzate" },
                },
                [_vm._v(" mdi-cloud-check ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }